import { useLanguage } from '../utils/LanguageContext';
import { ValidatedForm, FormSubmit, FormInput } from './common/ValidatedForm';
import { activateUserEmploymentSchema } from '../shared/validations/userValidations';
import translations from '../components/ComponentsTranslations.lang.json';
import { useAuth } from '../utils/AuthContext.js';
import { useActivationCodeData } from './common/activationCodeHook.js';
import { Alert } from 'antd';

const VerifyTaxIdForm = ({ activationCode, onFinish }) => {
  const { lang } = useLanguage(translations);
  const { api } = useAuth();

  const { employerName, expired, invalid, reloadActivationData } = useActivationCodeData(activationCode);

  if (invalid) {
    return <Alert description={lang('activationCodeIsInvalid')} />;
  }
  if (expired) {
    return <Alert description={lang('activationCodeIsExpired')} />;
  }

  const handleSubmitAndReloadActivationDataOnError = async (values) => {
    try {
      await api.activateUserEmployment(values);
    } catch (error) {
      await reloadActivationData();
      throw error;
    }
  };

  return (
    <ValidatedForm
      schema={activateUserEmploymentSchema}
      initialValues={{ activationCode }}
      handleSubmit={handleSubmitAndReloadActivationDataOnError}
      onFinish={onFinish}
    >
      <Alert
        type="info"
        description={
          <>
            <b>{employerName}</b>
            <br />
            {lang('employerTaxIdMatchRequired')}
          </>
        }
      />

      <FormInput name="taxId" type="text" />
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default VerifyTaxIdForm;
